import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { ExpenseTravel, type ExpenseTravelConstructor } from './ExpenseTravel'

export const ExpenseTravelConstructorFactory =
  Factory.Sync.makeFactory<ExpenseTravelConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    purpose: Factory.each(() => faker.lorem.sentence()),
  })

export const ExpenseTravelFactory = EntityFactory(
  ExpenseTravel,
  ExpenseTravelConstructorFactory
)
